import AdminIcon from "../icons/AdminIcon.svg?react";
import AdvancedSearchIcon from "../icons/AdvancedSearchIcon.svg?react";
import ArrowLeftIcon from "../icons/ArrowLeftIcon.svg?react";
import ArrowRightIcon from "../icons/ArrowRightIcon.svg?react";
import AttachFileIcon from "../icons/AttachFileIcon.svg?react";
import BlueLockIcon from "../icons/BlueLockIcon.svg?react";
import BoltIcon from "../icons/BoltIcon.svg?react";
import BrandLinksImage1 from "../icons/BrandLinksImage1.svg?react";
import BrandLinksImage2 from "../icons/BrandLinksImage2.svg?react";
import CancelSubscriptionDone from "../icons/CancelSubscriptionDone.svg?react";
import CaretLeft from "../icons/CaretLeft.svg?react";
import CaretLeftDouble from "../icons/CaretLeftDouble.svg?react";
import CaretRight from "../icons/CaretRight.svg?react";
import CaretRightDouble from "../icons/CaretRightDouble.svg?react";
import ChartBarIcon from "../icons/ChartBarIcon.svg?react";
import CheckmarkIcon from "../icons/CheckmarkIcon.svg?react";
import ClockIcon from "../icons/ClockIcon.svg?react";
import CloseIcon from "../icons/CloseIcon.svg?react";
import CloseIconCircled from "../icons/CloseIconCircled.svg?react";
import CloudErrIcon from "../icons/CloudErrIcon.svg?react";
import CloudIcon from "../icons/CloudIcon.svg?react";
import ColapseIcon from "../icons/ColapseIcon.svg?react";
import ConciergeInstallationImage from "../icons/ConciergeInstallationImage.svg?react";
import CopyIcon from "../icons/CopyIcon.svg?react";
import DangerIcon from "../icons/DangerIcon.svg?react";
import DescriptionIcon from "../icons/DescriptionIcon.svg?react";
import EditIcon from "../icons/EditIcon.svg?react";
import ExpandIcon from "../icons/ExpandIcon.svg?react";
import ExternalLinkIcon from "../icons/ExternalLinkIcon.svg?react";
import FilterIcon from "../icons/FilterIcon.svg?react";
import FourHeadedArrowMoveIcon from "../icons/FourHeadedArrowMoveIcon.svg?react";
import GoogleIcon from "../icons/GoogleIcon.svg?react";
import GreenCheckmarkIcon from "../icons/GreenCheckmarkIcon.svg?react";
import GreenLockIcon from "../icons/GreenLockIcon.svg?react";
import GreyCheckmarkIcon from "../icons/GreyCheckmarkIcon.svg?react";
import GreyCrossmarkIcon from "../icons/GreyCrossmarkIcon.svg?react";
import IconDown from "../icons/IconDown.svg?react";
import IconUp from "../icons/IconUp.svg?react";
import InfoIcon from "../icons/InfoIcon.svg?react";
import InvoiceIcon from "../icons/InvoiceIcon.svg?react";
import JsonLdIcon from "../icons/JsonLdIcon.svg?react";
import LinkIcon from "../icons/LinkIcon.svg?react";
import LogoutIcon from "../icons/LogoutIcon.svg?react";
import MapIcon from "../icons/MapIcon.svg?react";
import MemberIcon from "../icons/MemberIcon.svg?react";
import NeedSetupIcon from "../icons/NeedSetupIcon.svg?react";
import NicheLinksImage from "../icons/NicheLinksImage.svg?react";
import NoDashboardSites from "../icons/NoDashboardSites.svg?react";
import PendingProcessPic from "../icons/PendingProcessPic.svg?react";
import PercentDownIcon from "../icons/PercentDownIcon.svg?react";
import PercentUpIcon from "../icons/PercentUpIcon.svg?react";
import PlainCloseIcon from "../icons/PlainCloseIcon.svg?react";
import PlusIcon from "../icons/PlusIcon.svg?react";
import QuestionMarkInCircleIcon from "../icons/QuestionMarkInCircleIcon.svg?react";
import RecoveryLinkSent from "../icons/RecoveryLinkSent.svg?react";
import RedCrossmarkIcon from "../icons/RedCrossmarkIcon.svg?react";
import RedLockIcon from "../icons/RedLockIcon.svg?react";
import RefreshIcon from "../icons/RefreshIcon.svg?react";
import ResizeHorizontalIcon from "../icons/ResizeHorizontalIcon.svg?react";
import ResizeVerticalIcon from "../icons/ResizeVerticalIcon.svg?react";
import SearchIcon from "../icons/SearchIcon.svg?react";
import SiteFaviconPlaceholder from "../icons/SiteFaviconPlaceholder.svg?react";
import SiteSpeedErrIcon from "../icons/SiteSpeedErrIcon.svg?react";
import SiteSpeedIcon from "../icons/SiteSpeedIcon.svg?react";
import SiteSpeedWarnIcon from "../icons/SiteSpeedWarnIcon.svg?react";
import SnippetErrIcon from "../icons/SnippetErrIcon.svg?react";
import SnippetIcon from "../icons/SnippetIcon.svg?react";
import SortingIcon from "../icons/SortingIcon.svg?react";
import SortingIconDown from "../icons/SortingIconDown.svg?react";
import SortingIconUp from "../icons/SortingIconUp.svg?react";
import StarIcon from "../icons/StarIcon.svg?react";
import TitleIcon from "../icons/TitleIcon.svg?react";
import TrashIcon from "../icons/TrashIcon.svg?react";
import TreeDotsButtonIcon from "../icons/TreeDotsButtonIcon.svg?react";
import UserIcon from "../icons/UserIcon.svg?react";
import VersionsIcon from "../icons/VersionsIcon.svg?react";
import WarningIcon from "../icons/WarningIcon.svg?react";
import MasterCardIcon from "../icons/cards/MasterCardIcon.svg?react";
import VisaCardIcon from "../icons/cards/VisaCardIcon.svg?react";
import APIKeysIcon from "../icons/menuIcons/APIKeysIcon.svg?react";
import AnalyticsIcon from "../icons/menuIcons/AnalyticsIcon.svg?react";
import BillingIcon from "../icons/menuIcons/BillingIcon.svg?react";
import ContentIcon from "../icons/menuIcons/ContentIcon.svg?react";
import DashboardIcon from "../icons/menuIcons/DashboardIcon.svg?react";
import EyeIcon from "../icons/menuIcons/EyeIcon.svg?react";
import GlobeIcon from "../icons/menuIcons/GlobeIcon.svg?react";
import HelpCenterIcon from "../icons/menuIcons/HelpCenterIcon.svg?react";
import InterlinksIcon from "../icons/menuIcons/InterlinksIcon.svg?react";
import KeywordsIcon from "../icons/menuIcons/KeywordsIcon.svg?react";
import LinksIcon from "../icons/menuIcons/LinksIcon.svg?react";
import LiveEditorIcon from "../icons/menuIcons/LiveEditorIcon.svg?react";
import NotificationIcon from "../icons/menuIcons/NotificationIcon.svg?react";
import OnPageIcon from "../icons/menuIcons/OnPageIcon.svg?react";
import PagesIcon from "../icons/menuIcons/PagesIcon.svg?react";
import PagesIconProcessing from "../icons/menuIcons/PagesIconProcessing.svg?react";
import ReportsIcon from "../icons/menuIcons/ReportsIcon.svg?react";
import SchemaIcon from "../icons/menuIcons/SchemaIcon.svg?react";
import ServicesIcon from "../icons/menuIcons/ServicesIcon.svg?react";
import SettingIcon from "../icons/menuIcons/SettingIcon.svg?react";
import SiteSettingsIcon from "../icons/menuIcons/SiteSettingsIcon.svg?react";
import SiteSpeedMenuIcon from "../icons/menuIcons/SiteSpeedIcon.svg?react";
import TeamIcon from "../icons/menuIcons/TeamIcon.svg?react";
import ThemeControl from "../icons/menuIcons/ThemeControl.svg?react";

export const IconMap = {
  AdvancedSearchIcon,
  NotificationIcon,
  HelpCenterIcon,
  UserIcon,
  BillingIcon,
  IconDown,
  IconUp,
  CaretLeft,
  CaretRight,
  CaretLeftDouble,
  CaretRightDouble,
  ArrowLeftIcon,
  ArrowRightIcon,
  TeamIcon,
  ServicesIcon,
  APIKeysIcon,
  DashboardIcon,
  SettingIcon,
  MasterCardIcon,
  VisaCardIcon,
  TreeDotsButtonIcon,
  TrashIcon,
  EditIcon,
  ExternalLinkIcon,
  VersionsIcon,
  WarningIcon,
  DangerIcon,
  CloseIcon,
  CloudIcon,
  CloudErrIcon,
  PlainCloseIcon,
  InvoiceIcon,
  InfoIcon,
  PlusIcon,
  RecoveryLinkSent,
  CancelSubscriptionDone,
  GreenCheckmarkIcon,
  RefreshIcon,
  ResizeHorizontalIcon,
  ResizeVerticalIcon,
  RedCrossmarkIcon,
  SearchIcon,
  PercentDownIcon,
  PercentUpIcon,
  GreenLockIcon,
  BlueLockIcon,
  RedLockIcon,
  LinkIcon,
  NoDashboardSites,
  AttachFileIcon,
  CopyIcon,
  PendingProcessPic,
  GreyCheckmarkIcon,
  ClockIcon,
  ChartBarIcon,
  MapIcon,
  SiteSettingsIcon,
  AnalyticsIcon,
  PagesIcon,
  PagesIconProcessing,
  LiveEditorIcon,
  LinksIcon,
  GoogleIcon,
  KeywordsIcon,
  ReportsIcon,
  SiteSpeedIcon,
  SiteSpeedWarnIcon,
  SiteSpeedErrIcon,
  SiteSpeedMenuIcon,
  EyeIcon,
  GlobeIcon,
  SnippetIcon,
  SnippetErrIcon,
  OnPageIcon,
  ContentIcon,
  SchemaIcon,
  CheckmarkIcon,
  BrandLinksImage1,
  BrandLinksImage2,
  NicheLinksImage,
  ConciergeInstallationImage,
  SiteFaviconPlaceholder,
  FilterIcon,
  FourHeadedArrowMoveIcon,
  BoltIcon,
  ColapseIcon,
  ExpandIcon,
  SortingIcon,
  SortingIconUp,
  SortingIconDown,
  StarIcon,
  CloseIconCircled,
  InterlinksIcon,
  LogoutIcon,
  QuestionMarkInCircleIcon,
  NeedSetupIcon,
  MemberIcon,
  GreyCrossmarkIcon,
  AdminIcon,
  ThemeControl,
  TitleIcon,
  DescriptionIcon,
  JsonLdIcon,
};
